import { DetailWrapper } from "../../../../../features/ui"
import { CheckDetail } from "./checkDetail"

export const CheckDetailLoader = () => (
    <DetailWrapper>
        <CheckDetail />
    </DetailWrapper>
)
